import React from 'react';
import './ErrorMessage.scss';

/**
 * Renders an error message
 *
 * @param {string} message - the error message to be shown
 * @returns {JSX.Element}
 * @constructor
 */
const ErrorMessage = ({ message }) => (
  <span className="c-error-message body-3 color-white">{message}</span>
);

export default ErrorMessage;
